var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayAudio = function SvgIconPlayAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.206 10.956 5.354 1.448a3.589 3.589 0 0 0-3.608.028A3.469 3.469 0 0 0-.001 4.493v19.015a3.468 3.468 0 0 0 1.747 3.016 3.59 3.59 0 0 0 3.608.028l16.852-9.508a3.48 3.48 0 0 0 0-6.088Z"
  })));
};
export default SvgIconPlayAudio;